import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, notFound } from "@tanstack/react-router"

import { logger } from "@repo/utils/logger"
import { ResourceInvoiceForm } from "~/modules/resources/components/resource-invoice-form"
import {
  RESOURCE_EDITABLE_RESOURCE_INVOICE_STATUSES,
  type ResourceEditableResourceInvoiceStatus,
} from "~/modules/resources/resource-invoices.constants"
import { getExtendedResourceInvoiceQueryOptions } from "~/modules/resources/resource-invoices.queries"

const log = logger.child({
  module: "my-invoices-invoice-route",
})

export const Route = createFileRoute(
  "/_protected-layout/_os-layout/my-invoices/$invoiceId",
)({
  component: RouteComponent,
  preload: false,
  loader: async ({ context, params }) => {
    const { invoiceId } = params

    context.queryClient
      .ensureQueryData(getExtendedResourceInvoiceQueryOptions({ invoiceId }))
      .catch((error) => {
        log.error("Error getting extended resource invoice", { error })
        return null
      })

    return {
      invoiceId,
    }
  },
})

function RouteComponent() {
  const { invoiceId } = Route.useLoaderData()

  const { data: invoice } = useSuspenseQuery(
    getExtendedResourceInvoiceQueryOptions({ invoiceId }),
  )

  if (!invoice) {
    throw notFound()
  }

  return (
    <ResourceInvoiceForm
      key={invoiceId}
      invoice={invoice}
      isEditable={RESOURCE_EDITABLE_RESOURCE_INVOICE_STATUSES.includes(
        invoice.status as ResourceEditableResourceInvoiceStatus,
      )}
      isAdmin={false}
    />
  )
}
